import React from "react";

import { Col } from "reactstrap";
import '../styles/FiltroEstado.css'
const FiltroEstado = ({
  contador,
  casosList,
  dispatch,
  casosLista,
  groups,
  casosFilter,
  botonActivo,
setBotonActivo,
}) => {

 


  return (
    <React.Fragment>
      <Col
      //  md={12} 
      // className={`${styles.buttonsEstado}`}
      className=" justify-content-center mb-2 col-estado"
      >
        <button
          style={{ boxShadow: botonActivo === "TODOS" ? "0px 0px 5px 4px rgba(0, 0, 0, 0.3)" : "none"}}
          className="btn btn-sm btn-primary ms-1"
          onClick={() => {
            dispatch(casosList());
            setBotonActivo('TODOS')
            }}
        >
          TODOS{" "}
          <span
            className="badge bg-danger rounded-pill "
            style={{ fontSize: "15px" }}
          >
            {" "}
            {contador.contadorTODOS}
          </span>
        </button>

        {groups.includes("SuperAdmin") || groups.includes("Supervisor") ? (
          <button
          className="btn btn-sm ms-1" style={{ boxShadow: botonActivo === "EN_ESPERA" ? "0px 0px 5px 4px rgba(0, 0, 0, 0.3)" : "none", background:'#8e8c84'}}
            onClick={() => {
              setBotonActivo("EN_ESPERA");
            dispatch(casosFilter(`?estatus=EN ESPERA`))
            }}
          >
            EN ESPERA{" "}
            <span
              className="badge bg-danger rounded-pill "
              style={{ fontSize: "15px" }}
            >
              {" "}
              {contador.contadorENESPERA}
            </span>
          </button>
        ) : null}

        <button
          className="btn btn-sm btn-danger ms-1" style={{ boxShadow: botonActivo === "ASIGNADO" ? "0px 0px 5px 4px rgba(0, 0, 0, 0.3)" : "none"}}
          onClick={() => {
            dispatch(casosFilter(`?estatus=ASIGNADO`))
            setBotonActivo("ASIGNADO");
          }}
        >
          ASIGNADO{" "}
          <span
            className="badge bg-danger rounded-pill "
            style={{ fontSize: "15px" }}
          >
            {" "}
            {contador.contadorASIGNADO}
          </span>
        </button>

        <button
        className="btn btn-sm  bg-soft ms-1" style={{ boxShadow: botonActivo === "ACEPTAR" ? "0px 0px 5px 4px rgba(0, 0, 0, 0.3)" : "none", background:'#0c66e4'}}
          onClick={() => {
            dispatch(casosFilter(`?estatus=ACEPTAR`))
            setBotonActivo("ACEPTAR");
          }}
        >
          ACEPTADO
          <span
            className="badge bg-danger rounded-pill "
            style={{ fontSize: "15px" }}
          >
            {" "}
            {contador.contadorACEPTAR}
          </span>
        </button>
        <button
        
          className="btn btn-sm  btn-dark mx-2"
          style={{ boxShadow: botonActivo === "INICIAR" ? "0px 0px 5px 4px rgba(0, 0, 0, 0.3)" : "none"}}
          onClick={() => {
            dispatch(casosFilter(`?estatus=INICIAR`))
            setBotonActivo("INICIAR");
          }}
        >
          INICIADO
          <span
            className="badge bg-danger rounded-pill "
            style={{ fontSize: "15px" }}
          >
            {" "}
            {contador.contadorINICIAR}
          </span>
        </button>
        <button
          style={{ boxShadow: botonActivo === "PAUSAR" ? "0px 0px 5px 4px rgba(0, 0, 0, 0.3)" : "none"}}
          className="btn btn-sm  btn-secondary waves-effect waves-light mx-2"
          onClick={() => {
            dispatch(casosFilter(`?estatus=PAUSAR`))
            setBotonActivo("PAUSAR");
          }}
        >
          PAUSADO
          <span
            className="badge  bg-danger rounded-pill "
            style={{ fontSize: "15px" }}
          >
            {" "}
            {contador.contadorPAUSAR}
          </span>
        </button>
        <button
          style={{ boxShadow: botonActivo === "REINICIAR" ? "0px 0px 5px 4px rgba(0, 0, 0, 0.3)" : "none"}}
          className="btn btn-sm btn-info waves-effect waves-light mx-2"
          onClick={() => {
            dispatch(casosFilter(`?estatus=REINICIAR`))
            setBotonActivo("REINICIAR");
          }}
        >
          REINICIADO
          <span
            className="badge bg-danger rounded-pill "
            style={{ fontSize: "15px" }}
          >
            {" "}
            {contador.contadorREINICIAR}
          </span>
        </button>
        <button
           style={{ boxShadow: botonActivo === "FINALIZAR" ? "0px 0px 5px 4px rgba(0, 0, 0, 0.3)" : "none"}}

          className="btn btn-sm  btn-success waves-effect waves-light mx-2"
          onClick={() => {
            dispatch(casosFilter(`?estatus=FINALIZAR`))
            setBotonActivo("FINALIZAR");
          }}
        >
          FINALIZADO
          <span
            className="badge bg-danger rounded-pill "
            style={{ fontSize: "15px" }}
          >
            {" "}
            {contador.contadorFINALIZAR}
          </span>
        </button>
      </Col>
    </React.Fragment>
  );
};

export default FiltroEstado;
